/* global axios */

import ApiClient from './ApiClient';

class SystemConfigs extends ApiClient {
  constructor() {
    super('system_configs', { accountScoped: false });
  }

  get(type) {
    return axios.get(`${this.url}/${type}`);
  }

  update(updateData) {
    return axios.post(`${this.url}/update`, updateData);
  }
}

export default new SystemConfigs();
